import { connect } from 'react-redux';

import { getRadioOptions } from 'src/reducers/selectOptions';
import { setClientAllowances, getClientAllowances, saveDisplayOrder } from 'src/reducers/clients/allowances';
import ChangeAllowanceDisplayOrder from '../components/ChangeAllowanceDisplayOrder';

export default connect(
  (state, ownProps) => ({
    allowanceTypes: getRadioOptions(state, 'allowanceTypes'),
    internalAllowances: getClientAllowances(state),
    payrollRulesGroup: ownProps.payrollRulesGroup
  }),
  (dispatch, ownProps) => ({
    setAllowances: allowances => {
      dispatch(setClientAllowances(allowances));
    },
    saveDisplayOrder: () => {
      dispatch(saveDisplayOrder(ownProps.payrollRulesGroup.id));
    }
  })
)(ChangeAllowanceDisplayOrder);
